import { Button } from '@emotive/ui-core';
import PropTypes from 'prop-types';

import { ReactComponent as GoogleLogoBrand } from './../images/google-logo.svg';
import { ReactComponent as ShopifyLogoBrand } from './../images/shopify-logo.svg';

const FormSeparator = ({ children, ...rest }) => {
  return (
    <div tw="flex items-center gap-5" {...rest}>
      <div tw="flex-grow h-0.5 border-t border-gray-500" />
      <div tw="text-sm font-medium uppercase leading-4 text-medium">
        {children}
      </div>
      <div tw="flex-grow h-0.5 border-t border-gray-500" />
    </div>
  );
};
FormSeparator.propTypes = {
  children: PropTypes.node.isRequired,
};

const FormCTAButton = ({ type, onClick, ...rest }) => {
  const Logo = type === 'google' ? GoogleLogoBrand : ShopifyLogoBrand;
  return (
    <Button
      variant="tertiary"
      data-testid={`login-with-${type}-option-button`}
      onClick={onClick}
      tw="font-medium"
      {...rest}
    >
      <Logo tw="mr-2" /> Continue with
      <span tw="ml-1 first-letter:uppercase">{type}</span>
    </Button>
  );
};
FormCTAButton.propTypes = {
  type: PropTypes.oneOf(['google', 'shopify']).isRequired,
  onClick: PropTypes.func.isRequired,
};

export { FormSeparator, FormCTAButton };
